import api from '../../../api/client';
import React, { useState, useEffect } from "react";
import { Card, message, Button, Tooltip, Spin } from "antd";
import { ProTable } from "@ant-design/pro-table";
import { DownloadOutlined, FilePdfOutlined } from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import { saveAs } from "file-saver";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import config from "../../../config";

const LoginLogs = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const environment = window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;

  useEffect(() => {
    fetchLoginLogs();
  }, []);

  const fetchLoginLogs = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/logs`);
      setData(data);
    } catch (err) {
      message.error("Failed to fetch login logs");
    } finally {
      setLoading(false);
    }
  };

  const exportToCSV = () => {
    if (!data.length) return message.warning("No data to export");
    const headers = ["ID", "Username", "User ID", "IP Address", "Browser", "Action", "Timestamp"];
    const rows = data.map(log => [
      log.id,
      log.username,
      log.userId,
      log.ip,
      log.browser,
      log.action,
      dayjs(log.timestamp).format("YYYY-MM-DD HH:mm:ss"),
    ]);
    const csvContent = [headers, ...rows].map(row => row.join(",")).join("\n");
    const blob = new Blob(["\ufeff" + csvContent], { type: "text/csv;charset=utf-8" });
    saveAs(blob, `login_logs_${dayjs().format("YYYYMMDD_HHmmss")}.csv`);
    message.success("CSV exported");
  };

  const exportToPDF = () => {
    if (!data.length) return message.warning("No data to export");
    const doc = new jsPDF();
    doc.autoTable({
      head: [["ID", "Username", "User ID", "IP Address", "Browser", "Action", "Timestamp"]],
      body: data.map(log => [
        log.id,
        log.username,
        log.userId,
        log.ip,
        log.browser,
        log.action,
        dayjs(log.timestamp).format("YYYY-MM-DD HH:mm:ss"),
      ]),
    });
    doc.save(`login_logs_${dayjs().format("YYYYMMDD_HHmmss")}.pdf`);
    message.success("PDF exported");
  };

  const columns = [
    { title: "ID", dataIndex: "id", sorter: true, width: 70 },
    { title: "Timestamp", dataIndex: "timestamp", valueType: "dateTime", sorter: true, width: 180 },
    { title: "Username", dataIndex: "username", sorter: true },
    { title: "User ID", dataIndex: "userId", sorter: true },
    { title: "IP Address", dataIndex: "ip", sorter: true },
    { title: "Browser", dataIndex: "browser", ellipsis: true },
    { title: "Action", dataIndex: "action", sorter: true },
  ];

  const expandable = {
    expandedRowRender: (record) => {
      let location = null;
      try {
        location = record.location ? JSON.parse(record.location) : null;
      } catch (e) { console.error(e); }
      if (!location || !location.time_zone) {
        return <div>No location data</div>;
      }
      return (
        <div style={{ padding: 12 }}>
          <p><strong>City:</strong> {location.city}</p>
          <p><strong>Region:</strong> {location.state_prov}</p>
          <p><strong>Country:</strong> {location.country_name}</p>
          <p><strong>Timezone:</strong> {location.time_zone.name}</p>
          <p><strong>ISP:</strong> {location.isp}</p>
          <p><strong>Lat/Lng:</strong> {location.latitude}, {location.longitude}</p>
          <p><strong>Zip Code:</strong> {location.zipcode || "--"}</p>
          <p><strong>Browser:</strong> {record.browser}</p>
        </div>
      );
    },
  };

  return (
    <>
      <ProTable
      defaultSize="small"
        columns={columns}
        dataSource={data}
        rowKey="id"
        loading={loading}
        search={false}
        pagination={{ pageSize: 20, showSizeChanger: true }}
        expandable={expandable}
        toolBarRender={() => [
          <Tooltip title="Export CSV"><Button icon={<DownloadOutlined />} onClick={exportToCSV}>CSV</Button></Tooltip>,
          <Tooltip title="Export PDF"><Button icon={<FilePdfOutlined />} onClick={exportToPDF}>PDF</Button></Tooltip>,
        ]}
      />
    </>
  );
};

export default LoginLogs;